import React, { useRef } from "react";
import { useScrollReveal } from "../hooks";

const STEPS = [
  {
    n: "01",
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle cx="11" cy="11" r="7" stroke="currentColor" strokeWidth="1.5"/>
        <path d="M21 21l-4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
      </svg>
    ),
    title: "Understand",
    body: "We start by learning your business, your audience and what you actually need — not what sounds good on a proposal.",
  },
  {
    n: "02",
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M9 3H5a2 2 0 0 0-2 2v4m6-6h10a2 2 0 0 1 2 2v4M9 3v18m0 0h10a2 2 0 0 0 2-2v-4M9 21H5a2 2 0 0 1-2-2v-4m0 0h18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
    title: "Strategise",
    body: "We build a clear plan. What to build, why, in what order. No guesswork, no fluff.",
  },
  {
    n: "03",
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
    title: "Build",
    body: "We execute — brand, web, content, ads. Everything is crafted to work together as one system.",
  },
  {
    n: "04",
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M3 17l4-6 4 4 4-7 4 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M21 21H3" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/>
      </svg>
    ),
    title: "Grow",
    body: "We launch, measure, optimise and scale. Growth is not a one-time event — it's an ongoing process.",
  },
];

export default function Approach() {
  const ref = useRef(null);
  const visible = useScrollReveal(ref);

  return (
    <section id="approach" className={"section approach-dark reveal-section" + (visible ? " revealed" : "")} ref={ref}>
      <div className="container">

        <div className="appr-head reveal-child" style={{ transitionDelay: "0s" }}>
          <span className="eyebrow" style={{ color: "var(--gold)" }}>How We Work</span>
          <h2 className="h2" style={{ marginTop: 16, color: "var(--white)" }}>
            We start with your business. Not a service menu.
          </h2>
          <p className="lede" style={{ marginTop: 20, color: "var(--muted-dark)", maxWidth: 520 }}>
            Most agencies sell packages. We ask questions first. The right solution is the one built around what your business actually needs right now.
          </p>
        </div>

        <div className="appr-steps">
          {STEPS.map((s, i) => (
            <div className="appr-step reveal-child" key={s.n} style={{ transitionDelay: `${0.1 + i * 0.12}s` }}>
              <div className="appr-step-icon">{s.icon}</div>
              <span className="appr-step-num">{s.n}</span>
              <h3 className="appr-step-title">{s.title}</h3>
              <p className="appr-step-body">{s.body}</p>
            </div>
          ))}
        </div>

        <div className="appr-close reveal-child" style={{ transitionDelay: "0.58s" }}>
          <span className="appr-close-line">
            "The right solution isn't the biggest one. It's the one your business actually needs."
          </span>
        </div>

      </div>
    </section>
  );
}
